"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Hooks = __importStar(require("@apollo/react-hooks"));
var react_1 = __importDefault(require("react"));
var ApolloDefender_1 = require("../ApolloDefender");
var ApolloOperationError_1 = require("../ApolloOperationError");
function useMutation(mutation, options) {
    if (options === void 0) { options = {}; }
    var _a = __read(Hooks.useMutation(mutation, options), 2), mutate = _a[0], result = _a[1];
    var onError = ApolloDefender_1.useApolloDefender().onError;
    var simplyMutate = react_1.default.useCallback(function (variables, options) {
        if (options === void 0) { options = {}; }
        return mutate(__assign(__assign({}, options), { variables: variables }))
            .then(function (result) { return result.data; })
            .catch(function (error) {
            onError(new ApolloOperationError_1.ApolloOperationError(error, mutation, variables));
            throw error;
        });
    }, [mutate, mutation, onError]);
    return [simplyMutate, result];
}
exports.useMutation = useMutation;
//# sourceMappingURL=useMutation.js.map